import { useState } from 'react';

const useCustomHook = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [openAllowedProductsDialog, setOpenAllowedProductsDialog] = useState(false);
  const [dealerBizId, setDealerBizId] = useState(-1);
  const [allProductAllow, setAllProductAllow] = useState(false);
  const [dealingBusinessId, setDealingBusinessId] = useState(-1);
  const [loading, setLoading] = useState(false);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  return {
    openDialog,
    setOpenDialog,
    openAllowedProductsDialog,
    setOpenAllowedProductsDialog,
    dealerBizId,
    setDealerBizId,
    allProductAllow,
    setAllProductAllow,
    dealingBusinessId,
    setDealingBusinessId,
    loading, setLoading,
    size, setSize,
    page, setPage
  };
};

export default useCustomHook;
